// Comprehensive Cities Database - ~200 cities worldwide
// Includes major cities, photography destinations, and common aliases

export const cities = [
  // United States - Major Cities (30)
  { name: "New York City, NY", aliases: ["nyc", "ny", "new york", "manhattan", "big apple"] },
  { name: "Los Angeles, CA", aliases: ["la", "los angeles", "hollywood", "city of angels"] },
  { name: "San Francisco, CA", aliases: ["sf", "san fran", "bay area", "golden gate"] },
  { name: "Chicago, IL", aliases: ["chi", "chicago", "windy city", "chitown"] },
  { name: "Miami, FL", aliases: ["miami", "south beach", "magic city"] },
  { name: "Las Vegas, NV", aliases: ["vegas", "las vegas", "sin city", "lv"] },
  { name: "Seattle, WA", aliases: ["seattle", "emerald city", "sea"] },
  { name: "Boston, MA", aliases: ["boston", "beantown", "hub"] },
  { name: "Denver, CO", aliases: ["denver", "mile high city", "den"] },
  { name: "Portland, OR", aliases: ["portland", "pdx", "rose city"] },
  { name: "Austin, TX", aliases: ["austin", "atx", "music city"] },
  { name: "Nashville, TN", aliases: ["nashville", "music city", "nash"] },
  { name: "New Orleans, LA", aliases: ["nola", "new orleans", "big easy"] },
  { name: "San Diego, CA", aliases: ["san diego", "sd", "americas finest city"] },
  { name: "Phoenix, AZ", aliases: ["phoenix", "phx", "valley of the sun"] },
  { name: "Atlanta, GA", aliases: ["atlanta", "atl", "hotlanta"] },
  { name: "Washington, DC", aliases: ["dc", "washington", "dmv", "capital"] },
  { name: "Philadelphia, PA", aliases: ["philly", "philadelphia", "city of brotherly love"] },
  { name: "Dallas, TX", aliases: ["dallas", "dfw", "big d"] },
  { name: "Houston, TX", aliases: ["houston", "space city", "h-town"] },
  { name: "Orlando, FL", aliases: ["orlando", "o-town", "theme park capital"] },
  { name: "Tampa, FL", aliases: ["tampa", "cigar city"] },
  { name: "Detroit, MI", aliases: ["detroit", "motor city", "motown"] },
  { name: "Minneapolis, MN", aliases: ["minneapolis", "twin cities", "mini"] },
  { name: "Cleveland, OH", aliases: ["cleveland", "forest city", "cle"] },
  { name: "Kansas City, MO", aliases: ["kansas city", "kc", "bbq capital"] },
  { name: "Salt Lake City, UT", aliases: ["salt lake", "slc", "ski city"] },
  { name: "Honolulu, HI", aliases: ["honolulu", "paradise", "waikiki"] },
  { name: "Anchorage, AK", aliases: ["anchorage", "northern lights"] },
  { name: "Charleston, SC", aliases: ["charleston", "holy city", "charm city"] },

  // United States - Photography Destinations (15)
  { name: "Yosemite National Park, CA", aliases: ["yosemite", "valley", "half dome"] },
  { name: "Grand Canyon, AZ", aliases: ["grand canyon", "south rim", "north rim"] },
  { name: "Yellowstone, WY", aliases: ["yellowstone", "old faithful", "geysers"] },
  { name: "Zion National Park, UT", aliases: ["zion", "angels landing", "narrows"] },
  { name: "Antelope Canyon, AZ", aliases: ["antelope canyon", "slot canyon", "page"] },
  { name: "Bryce Canyon, UT", aliases: ["bryce canyon", "hoodoos", "amphitheater"] },
  { name: "Big Sur, CA", aliases: ["big sur", "coastal highway", "mcway falls"] },
  { name: "Monument Valley, UT", aliases: ["monument valley", "navajo nation", "buttes"] },
  { name: "Death Valley, CA", aliases: ["death valley", "badwater", "furnace creek"] },
  { name: "Glacier National Park, MT", aliases: ["glacier", "going to the sun", "montana"] },
  { name: "Arches National Park, UT", aliases: ["arches", "delicate arch", "moab"] },
  { name: "Joshua Tree, CA", aliases: ["joshua tree", "desert", "rock climbing"] },
  { name: "Crater Lake, OR", aliases: ["crater lake", "blue lake", "rim drive"] },
  { name: "Great Smoky Mountains, TN", aliases: ["smoky mountains", "smokies", "gatlinburg"] },
  { name: "Acadia National Park, ME", aliases: ["acadia", "bar harbor", "cadillac mountain"] },

  // Canada (15)
  { name: "Vancouver, BC", aliases: ["vancouver", "van", "rain city"] },
  { name: "Toronto, ON", aliases: ["toronto", "the six", "tdot"] },
  { name: "Montreal, QC", aliases: ["montreal", "mtl", "old montreal"] },
  { name: "Calgary, AB", aliases: ["calgary", "cowtown", "stampede city"] },
  { name: "Ottawa, ON", aliases: ["ottawa", "capital", "bytown"] },
  { name: "Quebec City, QC", aliases: ["quebec city", "old quebec", "fortress"] },
  { name: "Halifax, NS", aliases: ["halifax", "haligonia", "maritime"] },
  { name: "Winnipeg, MB", aliases: ["winnipeg", "winterpeg", "gateway"] },
  { name: "Edmonton, AB", aliases: ["edmonton", "festival city", "capital"] },
  { name: "Victoria, BC", aliases: ["victoria", "garden city", "island"] },
  { name: "Banff, AB", aliases: ["banff", "rocky mountains", "lake louise"] },
  { name: "Jasper, AB", aliases: ["jasper", "jasper national park", "rockies"] },
  { name: "Whistler, BC", aliases: ["whistler", "ski resort", "mountains"] },
  { name: "Tofino, BC", aliases: ["tofino", "surfing", "west coast"] },
  { name: "Niagara Falls, ON", aliases: ["niagara", "falls", "maid of the mist"] },

  // Europe - Major Cities (30)
  { name: "London, UK", aliases: ["london", "big ben", "thames", "britain"] },
  { name: "Paris, France", aliases: ["paris", "city of light", "eiffel tower"] },
  { name: "Rome, Italy", aliases: ["rome", "eternal city", "colosseum"] },
  { name: "Barcelona, Spain", aliases: ["barcelona", "barca", "catalonia"] },
  { name: "Amsterdam, Netherlands", aliases: ["amsterdam", "canals", "bikes"] },
  { name: "Berlin, Germany", aliases: ["berlin", "brandenburg gate", "wall"] },
  { name: "Vienna, Austria", aliases: ["vienna", "wien", "music city"] },
  { name: "Prague, Czech Republic", aliases: ["prague", "golden city", "bohemia"] },
  { name: "Budapest, Hungary", aliases: ["budapest", "danube", "thermal baths"] },
  { name: "Stockholm, Sweden", aliases: ["stockholm", "venice of the north", "gamla stan"] },
  { name: "Copenhagen, Denmark", aliases: ["copenhagen", "little mermaid", "hygge"] },
  { name: "Oslo, Norway", aliases: ["oslo", "fjords", "northern lights"] },
  { name: "Helsinki, Finland", aliases: ["helsinki", "sauna", "midnight sun"] },
  { name: "Dublin, Ireland", aliases: ["dublin", "emerald isle", "guinness"] },
  { name: "Edinburgh, Scotland", aliases: ["edinburgh", "castle", "highlands"] },
  { name: "Zurich, Switzerland", aliases: ["zurich", "alps", "banking"] },
  { name: "Brussels, Belgium", aliases: ["brussels", "waffles", "eu capital"] },
  { name: "Lisbon, Portugal", aliases: ["lisbon", "trams", "atlantic"] },
  { name: "Madrid, Spain", aliases: ["madrid", "royal palace", "prado"] },
  { name: "Florence, Italy", aliases: ["florence", "renaissance", "duomo"] },
  { name: "Venice, Italy", aliases: ["venice", "canals", "gondolas"] },
  { name: "Naples, Italy", aliases: ["naples", "pizza", "vesuvius"] },
  { name: "Milan, Italy", aliases: ["milan", "fashion", "scala"] },
  { name: "Athens, Greece", aliases: ["athens", "acropolis", "parthenon"] },
  { name: "Istanbul, Turkey", aliases: ["istanbul", "bosphorus", "hagia sophia"] },
  { name: "Munich, Germany", aliases: ["munich", "oktoberfest", "bavaria"] },
  { name: "Warsaw, Poland", aliases: ["warsaw", "old town", "chopin"] },
  { name: "Krakow, Poland", aliases: ["krakow", "medieval", "wawel"] },
  { name: "Porto, Portugal", aliases: ["porto", "wine", "azulejos"] },
  { name: "Lyon, France", aliases: ["lyon", "gastronomy", "silk"] },

  // Europe - Photography Destinations (12)
  { name: "Santorini, Greece", aliases: ["santorini", "blue domes", "sunset"] },
  { name: "Mykonos, Greece", aliases: ["mykonos", "windmills", "party island"] },
  { name: "Tuscany, Italy", aliases: ["tuscany", "rolling hills", "wine country"] },
  { name: "Swiss Alps, Switzerland", aliases: ["swiss alps", "matterhorn", "jungfrau"] },
  { name: "Scottish Highlands, Scotland", aliases: ["highlands", "lochs", "castles"] },
  { name: "Iceland", aliases: ["iceland", "northern lights", "blue lagoon", "reykjavik"] },
  { name: "Lofoten Islands, Norway", aliases: ["lofoten", "midnight sun", "fishing villages"] },
  { name: "Cinque Terre, Italy", aliases: ["cinque terre", "five villages", "coastal"] },
  { name: "Hallstatt, Austria", aliases: ["hallstatt", "lake", "alpine village"] },
  { name: "Meteora, Greece", aliases: ["meteora", "monasteries", "rock formations"] },
  { name: "Amalfi Coast, Italy", aliases: ["amalfi", "coastal", "positano"] },
  { name: "Norwegian Fjords, Norway", aliases: ["fjords", "waterfalls", "geiranger"] },

  // Asia - Major Cities (25)
  { name: "Tokyo, Japan", aliases: ["tokyo", "shibuya", "cherry blossoms"] },
  { name: "Kyoto, Japan", aliases: ["kyoto", "temples", "geishas"] },
  { name: "Osaka, Japan", aliases: ["osaka", "food capital", "castle"] },
  { name: "Seoul, South Korea", aliases: ["seoul", "gangnam", "kimchi"] },
  { name: "Busan, South Korea", aliases: ["busan", "beaches", "coastal"] },
  { name: "Beijing, China", aliases: ["beijing", "forbidden city", "great wall"] },
  { name: "Shanghai, China", aliases: ["shanghai", "bund", "skyline"] },
  { name: "Hong Kong", aliases: ["hong kong", "hk", "victoria harbor"] },
  { name: "Macau", aliases: ["macau", "casinos", "portuguese"] },
  { name: "Singapore", aliases: ["singapore", "lion city", "marina bay"] },
  { name: "Bangkok, Thailand", aliases: ["bangkok", "temples", "street food"] },
  { name: "Chiang Mai, Thailand", aliases: ["chiang mai", "mountains", "temples"] },
  { name: "Phuket, Thailand", aliases: ["phuket", "beaches", "andaman"] },
  { name: "Hanoi, Vietnam", aliases: ["hanoi", "old quarter", "pho"] },
  { name: "Ho Chi Minh City, Vietnam", aliases: ["saigon", "ho chi minh", "mekong"] },
  { name: "Siem Reap, Cambodia", aliases: ["siem reap", "angkor wat", "temples"] },
  { name: "Kuala Lumpur, Malaysia", aliases: ["kl", "kuala lumpur", "petronas towers"] },
  { name: "Jakarta, Indonesia", aliases: ["jakarta", "java", "capital"] },
  { name: "Manila, Philippines", aliases: ["manila", "metro manila", "capital"] },
  { name: "Mumbai, India", aliases: ["mumbai", "bombay", "bollywood"] },
  { name: "Delhi, India", aliases: ["delhi", "new delhi", "red fort"] },
  { name: "Bangalore, India", aliases: ["bangalore", "bengaluru", "silicon valley"] },
  { name: "Chennai, India", aliases: ["chennai", "madras", "temple city"] },
  { name: "Jaipur, India", aliases: ["jaipur", "pink city", "rajasthan"] },
  { name: "Agra, India", aliases: ["agra", "taj mahal", "love monument"] },

  // Asia - Photography Destinations (10)
  { name: "Mount Fuji, Japan", aliases: ["mount fuji", "fuji san", "sacred mountain"] },
  { name: "Bagan, Myanmar", aliases: ["bagan", "temples", "hot air balloons"] },
  { name: "Halong Bay, Vietnam", aliases: ["halong bay", "limestone karsts", "cruise"] },
  { name: "Guilin, China", aliases: ["guilin", "li river", "karst mountains"] },
  { name: "Zhangjiajie, China", aliases: ["zhangjiajie", "avatar mountains", "pillars"] },
  { name: "Bali, Indonesia", aliases: ["bali", "rice terraces", "hindu temples"] },
  { name: "Ladakh, India", aliases: ["ladakh", "little tibet", "high altitude"] },
  { name: "Kerala, India", aliases: ["kerala", "backwaters", "gods own country"] },
  { name: "Goa, India", aliases: ["goa", "beaches", "portuguese"] },
  { name: "Maldives", aliases: ["maldives", "islands", "crystal waters"] },

  // Australia & New Zealand (12)
  { name: "Sydney, Australia", aliases: ["sydney", "harbour bridge", "opera house"] },
  { name: "Melbourne, Australia", aliases: ["melbourne", "coffee culture", "laneways"] },
  { name: "Brisbane, Australia", aliases: ["brisbane", "sunshine state", "river city"] },
  { name: "Perth, Australia", aliases: ["perth", "isolated city", "beaches"] },
  { name: "Adelaide, Australia", aliases: ["adelaide", "wine capital", "festival city"] },
  { name: "Darwin, Australia", aliases: ["darwin", "top end", "crocodiles"] },
  { name: "Cairns, Australia", aliases: ["cairns", "great barrier reef", "diving"] },
  { name: "Auckland, New Zealand", aliases: ["auckland", "city of sails", "harbour"] },
  { name: "Wellington, New Zealand", aliases: ["wellington", "windy city", "capital"] },
  { name: "Christchurch, New Zealand", aliases: ["christchurch", "garden city", "south island"] },
  { name: "Queenstown, New Zealand", aliases: ["queenstown", "adventure capital", "southern alps"] },
  { name: "Uluru, Australia", aliases: ["uluru", "ayers rock", "sacred site"] },

  // South America (15)
  { name: "São Paulo, Brazil", aliases: ["sao paulo", "sampa", "megacity"] },
  { name: "Rio de Janeiro, Brazil", aliases: ["rio", "copacabana", "christ the redeemer"] },
  { name: "Buenos Aires, Argentina", aliases: ["buenos aires", "tango", "paris of south america"] },
  { name: "Lima, Peru", aliases: ["lima", "capital", "ceviche"] },
  { name: "Cusco, Peru", aliases: ["cusco", "machu picchu gateway", "inca capital"] },
  { name: "Bogotá, Colombia", aliases: ["bogota", "capital", "andes"] },
  { name: "Medellín, Colombia", aliases: ["medellin", "city of eternal spring", "innovation"] },
  { name: "Cartagena, Colombia", aliases: ["cartagena", "walled city", "caribbean"] },
  { name: "Santiago, Chile", aliases: ["santiago", "andes", "wine country"] },
  { name: "Valparaíso, Chile", aliases: ["valparaiso", "port city", "street art"] },
  { name: "Quito, Ecuador", aliases: ["quito", "equator", "colonial"] },
  { name: "La Paz, Bolivia", aliases: ["la paz", "highest capital", "andes"] },
  { name: "Machu Picchu, Peru", aliases: ["machu picchu", "lost city", "inca ruins"] },
  { name: "Patagonia, Argentina/Chile", aliases: ["patagonia", "torres del paine", "glaciers"] },
  { name: "Iguazu Falls, Argentina/Brazil", aliases: ["iguazu falls", "waterfalls", "rainbow"] },

  // Africa (12)
  { name: "Cape Town, South Africa", aliases: ["cape town", "table mountain", "mother city"] },
  { name: "Johannesburg, South Africa", aliases: ["johannesburg", "joburg", "gold city"] },
  { name: "Cairo, Egypt", aliases: ["cairo", "pyramids", "nile"] },
  { name: "Marrakech, Morocco", aliases: ["marrakech", "red city", "medina"] },
  { name: "Casablanca, Morocco", aliases: ["casablanca", "hassan ii mosque", "atlantic"] },
  { name: "Nairobi, Kenya", aliases: ["nairobi", "safari capital", "green city"] },
  { name: "Lagos, Nigeria", aliases: ["lagos", "economic capital", "nollywood"] },
  { name: "Serengeti, Tanzania", aliases: ["serengeti", "great migration", "wildlife"] },
  { name: "Masai Mara, Kenya", aliases: ["masai mara", "big five", "wildebeest"] },
  { name: "Victoria Falls, Zambia/Zimbabwe", aliases: ["victoria falls", "mosi-oa-tunya", "thundering smoke"] },
  { name: "Sahara Desert, Morocco", aliases: ["sahara", "sand dunes", "camels"] },
  { name: "Zanzibar, Tanzania", aliases: ["zanzibar", "spice island", "beaches"] },

  // Middle East (8)
  { name: "Dubai, UAE", aliases: ["dubai", "burj khalifa", "luxury"] },
  { name: "Abu Dhabi, UAE", aliases: ["abu dhabi", "capital", "sheikh zayed mosque"] },
  { name: "Doha, Qatar", aliases: ["doha", "skyline", "pearls"] },
  { name: "Tel Aviv, Israel", aliases: ["tel aviv", "white city", "beaches"] },
  { name: "Jerusalem, Israel", aliases: ["jerusalem", "holy city", "old city"] },
  { name: "Petra, Jordan", aliases: ["petra", "rose city", "treasury"] },
  { name: "Wadi Rum, Jordan", aliases: ["wadi rum", "valley of the moon", "desert"] },
  { name: "Cappadocia, Turkey", aliases: ["cappadocia", "fairy chimneys", "hot air balloons"] }
];

// Search function with fuzzy matching and scoring
export const searchCities = (query, limit = 10) => {
  if (!query || query.length < 1) return [];
  
  const normalizedQuery = query.toLowerCase().trim();
  const results = [];
  
  cities.forEach(city => {
    let score = 0;
    let matchType = '';
    
    // Check exact name match
    if (city.name.toLowerCase() === normalizedQuery) {
      score = 1000;
      matchType = 'exact';
    }
    // Check if name starts with query
    else if (city.name.toLowerCase().startsWith(normalizedQuery)) {
      score = 900;
      matchType = 'starts_with';
    }
    // Check if name contains query
    else if (city.name.toLowerCase().includes(normalizedQuery)) {
      score = 700;
      matchType = 'contains';
    }
    
    // Check aliases
    city.aliases.forEach(alias => {
      const aliasLower = alias.toLowerCase();
      if (aliasLower === normalizedQuery) {
        score = Math.max(score, 950);
        matchType = 'alias_exact';
      } else if (aliasLower.startsWith(normalizedQuery)) {
        score = Math.max(score, 850);
        matchType = 'alias_starts';
      } else if (aliasLower.includes(normalizedQuery)) {
        score = Math.max(score, 650);
        matchType = 'alias_contains';
      }
    });
    
    // Boost score for shorter matches (more specific)
    if (score > 0) {
      const lengthBonus = Math.max(0, 50 - city.name.length);
      score += lengthBonus;
      
      results.push({
        city: city.name,
        score,
        matchType,
        displayText: city.name
      });
    }
  });
  
  // Sort by score (highest first) and return top results
  return results
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);
};

// Get popular suggestions for empty query
export const getPopularCities = (limit = 8) => {
  const popular = [
    "New York City, NY",
    "Los Angeles, CA", 
    "Paris, France",
    "London, UK",
    "Tokyo, Japan",
    "San Francisco, CA",
    "Rome, Italy",
    "Barcelona, Spain"
  ];
  
  return popular.slice(0, limit).map(city => ({
    city,
    displayText: city,
    score: 100,
    matchType: 'popular'
  }));
}; 